import { render } from "./AddSkill.vue?vue&type=template&id=5486e5d0&scoped=true"
import script from "./AddSkill.vue?vue&type=script&lang=js"
export * from "./AddSkill.vue?vue&type=script&lang=js"

import "./AddSkill.vue?vue&type=style&index=0&id=5486e5d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5486e5d0"

export default script